import { atom } from 'recoil';

export const selectedShop = atom({
  key: 'selectedShop',
  default: undefined,
});
